import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getSectorIcon } from '../../utils/sectorIcons';

const labels = {
  ne: {
    home: 'गृहपृष्ठ',
    priorityAreas: 'प्राथमिकता क्षेत्रहरू',
    submitPlan: 'आफ्नो योजना राख्नुहोस्',
  },
  en: {
    home: 'Home',
    priorityAreas: 'Priority Areas',
    submitPlan: 'Submit Your Plan',
  },
};

const SectorHero = ({ sector, prioritySector, language = 'ne' }) => {
  const IconComponent = getSectorIcon(sector || prioritySector);
  const t = labels[language] || labels.ne;
  const title = language === 'en' ? (prioritySector?.title || sector?.title) : (sector?.title || prioritySector?.title);

  return (
    <section className="sector-hero">
      <div className="sector-hero__bg-pattern" aria-hidden="true" />
      <div className="sector-hero__container">
        {/* Breadcrumb */}
        <div className="sector-hero__breadcrumb">
          <Link to="/" className="sector-hero__breadcrumb-link">
            <Home size={16} />
            {t.home}
          </Link>
          <ChevronRight size={16} />
          <Link to="/sectors" className="sector-hero__breadcrumb-link">
            {t.priorityAreas}
          </Link>
          <ChevronRight size={16} />
          <span className="sector-hero__breadcrumb-current">{title}</span>
        </div>

        {/* Hero Content */}
        <div className="sector-hero__content">
          <div className="sector-hero__left">
            <h1 className="sector-hero__title">{title}</h1>
            <div className="sector-hero__actions">
              <Link to={`/your-plan?sector=${encodeURIComponent(title || '')}`} className="btn btn-primary">
                {t.submitPlan}
              </Link>
            </div>
          </div>
          <div className="sector-hero__right">
            <div className="sector-hero__icon-wrapper">
              {IconComponent ? <IconComponent size={120} /> : <span style={{ fontSize: 100 }}>{sector.icon}</span>}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectorHero;
